import { render } from "./Trade.vue?vue&type=template&id=a2c21942&scoped=true&ts=true"
import script from "./Trade.vue?vue&type=script&lang=ts"
export * from "./Trade.vue?vue&type=script&lang=ts"

import "./Trade.vue?vue&type=style&index=0&id=a2c21942&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c21942"]])

export default __exports__